module.exports = __webpack_public_path__ + "static/media/WBNB2B_Industrial_manufacturers_global_exporters_B2B_2_California.74f77307.png";